import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/page-image/zscq/banner.png';
const _hoisted_1 = {
  class: "zscq-page"
};
const _hoisted_2 = {
  class: "content-wrapper"
};
const _hoisted_3 = {
  class: "left-section"
};
const _hoisted_4 = {
  class: "scroll-container"
};
const _hoisted_5 = ["src", "alt"];
const _hoisted_6 = {
  key: 1,
  class: "no-data"
};
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import SectionTitle from '@/components/SectionTitle.vue';
import Footer from '@/components/Footer.vue';
import { getHonorQualifications } from '@/api/honor';
export default /*@__PURE__*/_defineComponent({
  __name: 'Zscq',
  setup(__props) {
    const router = useRouter();
    // 知识产权列表数据
    const propertyList = ref([]);
    const handleSelect = item => {
      // console.log(item);
      router.push({
        path: item
      });
    };
    const handleMoreClick = () => {
      console.log('更多按钮被点击');
    };
    // 获取知识产权列表
    const fetchPropertyList = async () => {
      try {
        const res = await getHonorQualifications(2); // 2-知识产权
        propertyList.value = res.data || [];
      } catch (error) {
        console.error('获取知识产权列表失败：', error);
      }
    };
    onMounted(() => {
      fetchPropertyList();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "banner-wrapper"
      }, [_createElementVNode("div", {
        class: "banner-container"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "知识产权",
        class: "banner"
      })])], -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(SectionTitle, {
        title: "知识产权",
        onMoreClick: handleMoreClick,
        "show-more": false
      }), _createElementVNode("div", _hoisted_4, [propertyList.value.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(Math.ceil(propertyList.value.length / 3), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "item-row",
          key: index
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(propertyList.value.slice(index * 3, index * 3 + 3), property => {
          return _openBlock(), _createElementBlock("div", {
            class: "card",
            key: property.id
          }, [_createElementVNode("img", {
            src: property.url,
            alt: property.title,
            class: "card-img"
          }, null, 8, _hoisted_5)]);
        }), 128))]);
      }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_6, "暂无数据"))])])]), _createVNode(Footer)]);
    };
  }
});